// Import without an extension would be ambiguous, as the resolver cannot know
// if it is .css file that we want to import or a .css.ts file.
// Typescript is smart enough to understand that a `.js` extensions references a .ts file.
// In order to avoid custom tooling, resolvers, ect., we are opting to use an import with extension
// here.
import { internalSprinkles } from './sprinkles.sty.js';

/**
 * global sprinkles
 * @internal
 */
export function globalSprinkles(
  ...params: Parameters<typeof internalSprinkles>
): ReturnType<typeof internalSprinkles> {
  try {
    return internalSprinkles(...params);
  } catch (err) {
    if (process.env.NODE_ENV === 'development') {
      if (err instanceof Error) {
        // oxlint-disable-next-line no-console
        console.log(err.message);
      }
    }
  }
  return '';
}
